import {get, post} from '~/utils/request';

export function uploadLicence(data){
  return post('/Account/UploadLicence', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }});
}

export function saveLicenceToTemp(data){
  return post('/CompanySet/UploadLicence', data);
}

export function getValidFailReason(data){
  return get('/CompanySet/GetValidFailReason', data);
}

//获取人事：看过的人才
export function talentReadList(data){
  return post('/MyCenter/TalentReadList', data);
}
//获取人事：下载的简历
export function myDownloadResume(data){
  return post('/MyCenter/MyDownloadResume', data);
}